<template>
  <v-dialog v-model="dialogActive" width="600px">
    <template v-slot:activator="{ on: dialogOn }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-btn v-on="{ ...dialogOn, ...tooltipOn }" color="info" style="margin:.5em 0">Quiz Stats</v-btn>
        </template>
        <span>Check the efficacy of your quiz by looking at a breakdown of the results, seeing how many people got the correct answer{{ correctToProceed ? ' on the first try' : '' }}, as well as a breakdown of how many respondents chose each answer{{ correctToProceed ? ' on the first try' : '' }}.</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>Quiz Stats</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="dialogActive = false" icon>
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-expansion-panels v-model="expandedQuestion">
        <v-expansion-panel v-for="({label, answers, correctAnswer, chosenAnswer, count}, index) in questionStats" :key="'question-' + index">
          <v-expansion-panel-header>
            <v-row no-gutters>
              <v-col cols="9">{{ label }}</v-col>
              <v-col cols="3">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ correctToProceed ? 'First Try' : 'Correct'}}: {{ chosenAnswer[correctAnswer] / count * 100 }}%</span>
                  </template>
                  <span v-if="correctToProceed">Percentage of respondents who got the correct answer on their first try</span>
                  <span v-else>Percentage of respondents who got the correct answer</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list>
              <v-list-item v-for="({ text }, answerIndex) in answers" :key="'question-' + index + '-answer-' + answerIndex">
                <v-list-item-title>{{ text }}</v-list-item-title>
                <v-list-item-action>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ chosenAnswer[answerIndex] / count * 100 }}%</span>
                    </template>
                    <span>This answer was chosen {{ chosenAnswer[answerIndex] }} time{{ chosenAnswer[answerIndex] === 1 ? '' : 's'}}; {{ chosenAnswer[answerIndex] / count * 100 }}% of total respondents</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref, onMounted } from '@vue/composition-api'
export default {
  props: {
    id: {
      type: String,
      requird: true
    }
  },
  setup (props, { root }) {
    const dialogActive = ref(false)
    const expandedQuestion = ref(null)
    const correctToProceed = ref(false)
    const questionStats = ref([])

    onMounted(() => {
      root.$feathers.service('orientation/block').get(props.id).then((blockData) => {
        correctToProceed.value = blockData.correctToProceed
        let questions = []
        for (const { label, answers, correctAnswer } of blockData.questions) {
          let obj = {
            label,
            answers,
            correctAnswer,
            count: 0,
            chosenAnswer: []
          }
          for (let i = 0; i < answers.length; i++) {
            obj.chosenAnswer[i] = 0
          }
          questions.push(obj)
        }

        // Load the stats from the students who have submitted the quiz
        let query = { 'quizzes.section': blockData.section, 'quizzes.block': blockData._id, $limit: 0 }
        root.$feathers.service('orientation/tracker').find({ query }).then(async ({ total }) => {
          query.$limit = 10
          for (let i = 0; i < total; i += 10) {
            query.$skip = i
            let { data: trackerData } = await root.$feathers.service('orientation/tracker').find({ query })
            for (const { quizzes } of trackerData) {
              for (const { section, block, answers, firstAnswer } of quizzes) {
                if (section === blockData.section && JSON.stringify(blockData._id) === JSON.stringify(block)) {
                  // Matching quiz
                  for (let j = 0; j < questions.length; j++) {
                    let answer = null
                    if (blockData.correctToProceed && j in firstAnswer && typeof (firstAnswer[j]) === 'number') {
                      answer = firstAnswer[j]
                    } else if (!blockData.correctToProceed && j in answers && typeof (answers[j]) === 'number') {
                      answer = answers[j]
                    }
                    if (answer != null) {
                      questions[j].chosenAnswer[answer]++
                      questions[j].count++
                    }
                  }
                }
              }
            }
          }
          questionStats.value = questions
        })
      })
    })

    return {
      dialogActive,
      expandedQuestion,
      questionStats,
      correctToProceed
    }
  }
}
</script>
